// Native <details> disclosure for the "How we score" methodology note.
// Server-component friendly.

export function HowWeScoreDisclosure() {
  return (
    <details className="group">
      <summary className="inline-flex cursor-pointer list-none items-center gap-1.5 text-sm font-medium text-gray-700 transition-colors hover:text-green-700 [&::-webkit-details-marker]:hidden">
        How we score
        <span
          aria-hidden="true"
          className="inline-block h-2 w-2 rotate-45 border-b-[1.5px] border-r-[1.5px] border-current transition-transform group-open:rotate-[225deg]"
        />
      </summary>
      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-gray-600">
        Each grass gets a 0–5 rating on six traits drawn from university extension data
        (UGA, NC State, UF/IFAS, Penn State, PSU, Clemson, UMN). For each trait, the
        highest-rated grass earns a point. If you provide a ZIP, the grass earns up to
        two bonus points for being a strong match for your USDA climate zone. The
        highest total wins. Ties surface as "too close to call" so you can use the
        per-trait detail to decide.
      </p>
    </details>
  )
}
